import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// Node back-compat.
var ENCODING_MAPPING = {
  utf16le: 'utf-16le',
  ucs2: 'utf-16le',
  utf16be: 'utf-16be'
};
export var DecodeStream = /*#__PURE__*/function () {
  function DecodeStream(buffer) {
    _classCallCheck(this, DecodeStream);
    this.buffer = buffer;
    this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    this.pos = 0;
    this.length = this.buffer.length;
  }
  _createClass(DecodeStream, [{
    key: "readString",
    value: function readString(length) {
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascii';
      encoding = ENCODING_MAPPING[encoding] || encoding;
      var buf = this.readBuffer(length);
      try {
        var decoder = new TextDecoder(encoding);
        return decoder.decode(buf);
      } catch (err) {
        return buf;
      }
    }
  }, {
    key: "readBuffer",
    value: function readBuffer(length) {
      return this.buffer.slice(this.pos, this.pos += length);
    }
  }, {
    key: "readUInt24BE",
    value: function readUInt24BE() {
      return (this.readUInt16BE() << 8) + this.readUInt8();
    }
  }, {
    key: "readUInt24LE",
    value: function readUInt24LE() {
      return this.readUInt16LE() + (this.readUInt8() << 16);
    }
  }, {
    key: "readInt24BE",
    value: function readInt24BE() {
      return (this.readInt16BE() << 8) + this.readUInt8();
    }
  }, {
    key: "readInt24LE",
    value: function readInt24LE() {
      return this.readUInt16LE() + (this.readInt8() << 16);
    }
  }]);
  return DecodeStream;
}();
DecodeStream.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(DataView.prototype)),
  _step;
try {
  var _loop = function _loop() {
    var key = _step.value;
    if (key.slice(0, 3) === 'get') {
      var type = key.slice(3).replace('Ui', 'UI');
      if (type === 'Float32') {
        type = 'Float';
      } else if (type === 'Float64') {
        type = 'Double';
      }
      var bytes = DecodeStream.TYPES[type];
      DecodeStream.prototype['read' + type + (bytes === 1 ? '' : 'BE')] = function () {
        var ret = this.view[key](this.pos, false);
        this.pos += bytes;
        return ret;
      };
      if (bytes !== 1) {
        DecodeStream.prototype['read' + type + 'LE'] = function () {
          var ret = this.view[key](this.pos, true);
          this.pos += bytes;
          return ret;
        };
      }
    }
  };
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}